import { FC } from 'react';

const SoldLabel: FC = () => {
  return (
    <div
      className={`flex items-center justify-center w-fit bg-red200  text-white py-[2px] md:py-1 px-2 md:px-4 rounded-[3px] absolute md:text-xs bottom-8 left-[72%]`}
    >
      <div className="relative">
        <span className="text-sm font-icb">Såld</span>
        <div className="inline-block object-triangle sold absolute bottom-0 lg:-bottom-[4px] left-0 transform translate-y-1/1"></div>
      </div>
    </div>
  );
};

export default SoldLabel;
